import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_JUGADORES,
  ALL_JUGADORES,
  LOADING_ALL_JUGADORES,
} from './JugadoresReducer';
import {
  deleteJugadoresService,
  allJugadoresService,
  oneJugadoresService,
  saveJugadoresService,
} from './JugadoresService';

export const allJugadoresAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_JUGADORES, payload: true });
    const res = await allJugadoresService(params);
    dispatch({ type: ALL_JUGADORES, payload: res.data });
    dispatch({ type: LOADING_ALL_JUGADORES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_JUGADORES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveJugadoresAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveJugadoresService(id, data);
    notify(res.data.message);
    await allJugadoresAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoJugadoresAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_JUGADORES, payload: data });
};

export const oneJugadoresAction = async (dispatch, id) => {
  try {
    const res = await oneJugadoresService(id);
    await setActivoJugadoresAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteJugadoresAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteJugadoresService(id);
    notify(res.data.message);
    await setActivoJugadoresAction(dispatch, null);
    await allJugadoresAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
